export default function declarationToGeometry(declaration) {
    return declaration?.geometry?.value || null;
}
